import { Group, Box, Text, ThemeIcon } from "@mantine/core";
import type { TransitInfo, TransportType } from "@/api/types";
import { TransportIcon } from "./TransportIcon";

interface TransitSummaryProps {
  transitInfo: TransitInfo;
}

export function TransitSummary({ transitInfo }: TransitSummaryProps) {
  const transportTypes: TransportType[] = [];
  for (const leg of transitInfo.legs) {
    if (leg.type !== "WALK" && !transportTypes.includes(leg.type)) {
      transportTypes.push(leg.type);
    }
  }

  return (
    <Group gap="md">
      <Box
        style={{
          backgroundColor: "rgba(233, 69, 96, 0.1)",
          borderRadius: "0.5rem",
          padding: "0.5rem 0.75rem",
          textAlign: "center",
          minWidth: 60,
        }}
      >
        <Text size="xl" fw={700} c="primary" lh={1}>
          {transitInfo.duration_minutes}
        </Text>
        <Text size="xs" c="dimmed" mt={2}>
          min
        </Text>
      </Box>

      <Box style={{ flex: 1 }}>
        <Group gap="xs">
          <Group gap={4}>
            {transportTypes.map((type) => (
              <ThemeIcon key={type} size={28} radius="xl" variant="filled" color="#0f3460">
                <TransportIcon type={type} size="sm" />
              </ThemeIcon>
            ))}
          </Group>

          <Text size="sm" c="dimmed">
            {transitInfo.num_changes} {transitInfo.num_changes === 1 ? "change" : "changes"}
          </Text>
        </Group>

        <Text size="sm" c="dimmed" mt="xs">
          {transitInfo.departure_time} → {transitInfo.arrival_time}
        </Text>
      </Box>
    </Group>
  );
}
